import { useNavigate } from 'react-router';
import { MainLayout } from '../../layout/MainLayout.tsx'
import { Block, Flex, Typography } from '@aloft/toolkit-sui';
import { SectionButton } from './SectionButton.tsx';
import { useState } from 'react';
import { SectionID } from './types.ts';
import { Section } from './Section.tsx';
import { UserManagementContent } from './userManagement/UserManagementContent.tsx';
import { RegresssionModelling } from './regression/RegressionModelling.tsx';

export const AdminModule = () => {
  const navigate = useNavigate();
  const [activeSectionID, setActiveSectionID] = useState<SectionID>('users');
  return (
    <MainLayout
      title="Appraiser Toolkit"
      showBackButton
      showNav={false}
      onBackButtonClick={() => navigate('/')}
    >
      <Block
        className="account-module"
        width="100%"
        height="100%"
        padding="16px"
        backgroundColor="surface2"
        overflow="auto"
      >
        <Flex className="container" gap="16px">
          <Flex
            className="section-menu"
            backgroundColor="surface1"
            padding="16px 8px"
            borderRadius="4px"
            flexDirection="column"
            justifyContent="flex-start"
            gap={8}
          >
            <Flex flexDirection="column" gap="8px">
              <Block paddingX="8px">
                <Typography variant="h2">Admin</Typography>
              </Block>
              <SectionButton
                sectionID="users"
                activeSectionID={activeSectionID}
                setActiveSectionID={setActiveSectionID}
              />
            </Flex>
            <Flex flexDirection="column" gap="8px">
              <Block paddingX="8px">
                <Typography variant="h2">Tools</Typography>
              </Block>
              <SectionButton
                sectionID="regression"
                activeSectionID={activeSectionID}
                setActiveSectionID={setActiveSectionID}
              />
            </Flex>
          </Flex>
          <Block
            className="section-content"
            backgroundColor="surface1"
            padding="16px"
            borderRadius="4px"
          >
            <Section activeSectionID={activeSectionID} sectionID="users">
              <UserManagementContent />
            </Section>
            <Section activeSectionID={activeSectionID} sectionID="regression">
              <RegresssionModelling />
            </Section>
          </Block>
        </Flex>
      </Block>
    </MainLayout>
  )
}
